var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserInitiated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#74b3f5",
    d: "m2,14.5c0-1.93,1.57-3.5,3.5-3.5s3.5,1.57,3.5,3.5-1.57,3.5-3.5,3.5-3.5-1.57-3.5-3.5Zm13,0c0,1.93,1.57,3.5,3.5,3.5s3.5-1.57,3.5-3.5-1.57-3.5-3.5-3.5-3.5,1.57-3.5,3.5Zm6,4.5h-5c-1.654,0-3,1.346-3,3v2h11v-2c0-1.654-1.346-3-3-3Zm-6.072-10h3.072V2.048c0-1.129-.919-2.048-2.048-2.048h-7.904c-1.129,0-2.048.918-2.048,2.048v6.952h3.202l1.834,1.617c.29.256.653.384,1.016.384.358,0,.716-.126.998-.376l1.878-1.624Zm-6.928,10H3c-1.654,0-3,1.346-3,3v2h11v-2c0-1.654-1.346-3-3-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInitiated);
export default __webpack_public_path__ + "static/media/userInitiated.d3b33cafffabc502819d5eb80aec7ce1.svg";
export { ForwardRef as ReactComponent };